import { http } from '../../config/axios'

export default function postPlano(plano: any): Promise<string> {
  return http
    .post('api/plano', plano)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post plano', error)
      throw Error(error.response.data)
    })
}
